import type { AutoChargeEvent } from '../api/types';
import { toast } from '../components/toast';
import { t } from '../i18n';
import { useLive } from '../live/store';
import { navigateTo } from './nav';

// Kept apart from lib/charge.ts: live/socket imports this, and lib/charge imports api/queries (which imports the socket).
/** /ws/ui autoCharge → store, robot log, toasts. */
export function onAutoCharge(serial: string, ev: AutoChargeEvent) {
  const live = useLive.getState();
  const name = live.robots[serial]?.name ?? serial;
  const b = typeof ev.battery === 'number' ? Math.round(ev.battery) : (live.robots[serial]?.status?.battery ?? '?');
  live.setAutoCharge(serial, ev);
  live.addLog(serial, 'event', 'autoCharge', `${ev.phase}${typeof ev.battery === 'number' ? ` · ${b}%` : ''}${ev.reason ? ` · ${ev.reason}` : ''}`);
  const open = { label: t('stuck.openRobot'), onClick: () => navigateTo(`/robots/${encodeURIComponent(serial)}`) };
  if (ev.phase === 'low') toast(`${name}: ${t('charge.lowToast', { b })}`, 'warn');
  else if (ev.phase === 'docked') toast(`${name}: ${t('charge.dockedToast', { b })}`, 'ok');
  else if (ev.phase === 'failed') toast(`${name}: ${t('charge.failedToast')}`, 'err', open);
  else if (ev.phase === 'resumed') toast(`${name}: ${t('charge.resumedToast', { b })}`, 'info');
}
